export default [
    {
        text: 'Rut',
        value: 'rut',
        format: 'rut',
    },
    {
        text: 'r. social',
        value: 'business_name',
    },
    {
        text: 'nombre',
        value: 'alias_name',
    },
    {
        text: 'dirección',
        value: 'addressCustomer',
    },
]
